export const apiCreate = (): string => '/commercial/leads/'
export const apiListPagination = (): string => '/commercial/leads/pagination'
export const apiList = (id?: string): string =>
  !id ? '/commercial/leads/' : `/commercial/leads/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/leads/update/${id}`
export const apiDelete = (id: string): string => `/commercial/leads/${id}`
